<div>
  <br />
  <div class="row">
    <div class="col">
      <h3>{{ 'Senaste ordrar' | translate }}</h3>
    </div>
    <div class="col align-right">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'Period' | translate }}</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate [placeholder]="'Startdatum' | translate" [(ngModel)]="periodStart">
          <input matEndDate [placeholder]="'Slutdatum' | translate" [(ngModel)]="periodEnd">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
      <br />
    </div>
    <div class="col align-right">
      <mat-form-field class="fullwidth">
        <mat-label>{{ 'Statusar' | translate }}</mat-label>
        <mat-select multiple [(ngModel)]="statuses" (closed)="fetchOrders()">
          <mat-option [value]="'PENDING'">{{ 'Behandlas' | translate }}</mat-option>
          <mat-option [value]="'READY'">{{ 'Redo' | translate }}</mat-option>
          <mat-option [value]="'QUEUED_FOR_PRINT'">{{ 'Skickad till print' | translate }}</mat-option>
          <mat-option [value]="'PRINTED'">{{ 'Printad' | translate }}</mat-option>
          <mat-option [value]="'SHIPPED'">{{ 'Skickad' | translate }}</mat-option>
          <mat-option [value]="'DELIVERED'">{{ 'Levererad' | translate }}</mat-option>
          <mat-option [value]="'CANCELLED'">{{ 'Avbruten' | translate }}</mat-option>
          <mat-option [value]="'ERROR'">{{ 'Fel' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col align-right">
      <button mat-raised-button color="primary" (click)="fetchOrders()">{{ 'Uppdatera' | translate }}</button>
    </div>
  </div>
  <div class="row">

    <div class="col-12">
      <table class="fullwidth styled">
        <tr>
          <th>#</th>
          <th>{{ 'Namn' | translate }}</th>
          <th>{{ 'Producent' | translate }}</th>
          <th class="align-right">{{ 'Skapad' | translate }}</th>
          <th class="align-right">{{ 'Status' | translate }}</th>
          <th class="align-center" colspan="3">{{ 'Kostnader' | translate }}</th>
          <th class="align-center" colspan="3">{{ 'Kostnader (justerad)' | translate }}</th>
          <th class="align-center" colspan="3">{{ 'Intäkter' | translate }}</th>
          <th class="align-center">{{ 'Resultat' | translate }}</th>
        </tr>
        <tr class="sub-row">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="align-right">{{ 'Printfil' | translate }}</td>
          <td class="align-right">{{ 'Print' | translate }}</td>
          <td class="align-right">{{ 'Frakt' | translate }}</td>
          <td class="align-right">{{ 'Print' | translate }}</td>
          <td class="align-right">{{ 'Frakt' | translate }}</td>
          <td class="align-right">{{ 'Diff' | translate }}</td>
          <td class="align-right">{{ 'Print' | translate }}</td>
          <td class="align-right">{{ 'Frakt' | translate }}</td>
          <td class="align-right">{{ 'Total' | translate }}</td>
          <td class="align-right"></td>
        </tr>
        <ng-container *ngFor="let order of orders">
          <tr class="order"
            [ngClass]="{'ace-color': storesById[order.storeId].type.toLowerCase() == 'ace', 'partner-color': storesById[order.storeId].type.toLowerCase() == 'partner'}">
            <td>
              {{order.orderNumber}}
            </td>
            <td>
              <span *ngIf="order.shippingInfo">
                {{order.shippingInfo.firstName}} {{order.shippingInfo.lastName}}
              </span>
            </td>
            <td>{{getOrderFulfillmentPartners(order)}}</td>
            <td class="align-right">{{order.created | date : 'yyyy-MM-dd HH:mm'}}</td>

            <td class="align-right">
              <span *ngIf="order.status == 'PENDING'">{{ 'Behandlas' | translate }}</span>
              <span *ngIf="order.status == 'READY'">{{ 'Redo' | translate }}</span>
              <span *ngIf="order.status == 'QUEUED_FOR_PRINT'">{{ 'Skickad till print' | translate }}</span>
              <span *ngIf="order.status == 'PRINTED'">
                <div *ngIf="order.productionConfirmed">{{ 'Printad' | translate }}</div>
                <div *ngIf="!order.productionConfirmed">{{ 'Inväntar print' | translate }}</div>
              </span>
              <span *ngIf="order.status == 'SHIPPED'">{{ 'Skickad' | translate }}</span>
              <span *ngIf="order.status == 'DELIVERED'">{{ 'Levererad' | translate }}</span>
              <span *ngIf="order.status == 'CANCELLED'">{{ 'Avbruten' | translate }}</span>
              <span *ngIf="order.status == 'ERROR'">{{ 'Fel' | translate }}</span>
            </td>


            <!-- PRODUCTION -->
            <td class="align-right">
              <ng-container *ngIf="order.cost">
                {{utility.currencyFormat(order.cost.printFileCost)}}
              </ng-container>
            </td>


            <td class="align-right" [ngClass]="{'adjusted': order.costBeforeAdjustment}">
              <ng-container *ngIf="order.cost">
                <span
                  *ngIf="order.costBeforeAdjustment">{{utility.currencyFormat(order.costBeforeAdjustment.printCost)}}</span>

                <span *ngIf="!order.costBeforeAdjustment">{{utility.currencyFormat(order.cost.printCost)}}</span>
              </ng-container>
            </td>


            <td class="align-right" [ngClass]="{'adjusted': order.costBeforeAdjustment}">
              <ng-container *ngIf="order.cost">
                <span
                  *ngIf="order.costBeforeAdjustment">{{utility.currencyFormat(order.costBeforeAdjustment.shippingCost)}}</span>

                <span *ngIf="!order.costBeforeAdjustment">{{utility.currencyFormat(order.cost.shippingCost)}}</span>
              </ng-container>
            </td>


            <!-- PRODUCTION ADJUSTED -->

            <td class="align-right" [ngClass]="{'new-value': order.costBeforeAdjustment}">
              <ng-container *ngIf="order.cost && order.costBeforeAdjustment">
                {{utility.currencyFormat(order.cost.printCost)}}
              </ng-container>
            </td>


            <td class="align-right" [ngClass]="{'new-value': order.costBeforeAdjustment}">
              <ng-container *ngIf="order.cost && order.costBeforeAdjustment">
                {{utility.currencyFormat(order.cost.shippingCost)}}
              </ng-container>
            </td>


            <!-- DIFF -->
            <td class="align-right"
              [ngClass]="{'diff-value': order.costBeforeAdjustment, 'positive': getAdjustmentDiff(order) > 0, 'negative': getAdjustmentDiff(order) < 0}">
              <ng-container *ngIf="order.cost && order.costBeforeAdjustment">
                {{utility.currencyFormat(getAdjustmentDiff(order))}}
              </ng-container>
            </td>

            <!-- CREDIT COSTS -->
            <td class="align-right">
              <ng-container *ngIf="order.processingFee">
                {{utility.currencyFormat(order.processingFee.printCost)}}
              </ng-container>
            </td>

            <td class="align-right">
              <ng-container *ngIf="order.processingFee">
                {{utility.currencyFormat(order.processingFee.shippingCost)}}
              </ng-container>
            </td>

            <td class="align-right">
              <ng-container *ngIf="order.processingFee">
                {{utility.currencyFormat(order.processingFee.total)}}
              </ng-container>
            </td>

            <!-- RESULT -->
            <td class="align-right">
              <ng-container *ngIf="order.processingFee && order.cost">
                {{utility.currencyFormat(order.processingFee.total - order.cost.total)}}
              </ng-container>
            </td>
          </tr>
        </ng-container>

      </table>
    </div>
  </div>
</div>
